import { lazy } from 'react';
import { registerRemotes, loadRemote } from '@module-federation/enhanced/runtime';
export async function registerAndLoadRemote(appData, manifest) {
    registerRemotes([
        {
            name: appData.name,
            entry: `${manifest.publicPath}${manifest.entryFileName}`
        }
    ]);
    // Each remote's expose default-exports a thunk `() => import('./Real')` —
    // the dynamic import inside is the async boundary that makes shared-dep
    // consume sites compile to async loadShare (race-free across concurrent
    // remotes) instead of the eager codegen path. The thunk file is generated
    // by @honeybook/config-apps from apps.json#rootModule.path; apps don't
    // hand-write it. We wrap the thunk in React.lazy here so callers receive
    // a ready-to-render React component.
    const module = await loadRemote(`${appData.name}/${appData.rootModule.name}`);
    if (!module?.default) {
        return undefined;
    }
    const Component = Object.assign(lazy(module.default), {
        displayName: appData.rootModule.name
    });
    return Component;
}
//# sourceMappingURL=register-and-load-remote.js.map